import React from "react";

export default ({ width, height, fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 70"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9992 47.4867V47.4859H9.56761V44.5093H14.653V44.7099C14.653 45.0377 14.9146 45.3046 15.2393 45.3046C15.5614 45.3046 15.8243 45.0377 15.8243 44.7099V43.6186C15.8243 43.4538 15.6942 43.32 15.531 43.32H8.98262C8.64512 43.32 8.39762 43.5961 8.39453 43.9146V52.246C8.39453 52.5743 8.65703 52.8407 8.98262 52.8407V52.8416H13.9992V52.8407C15.4427 52.823 16.6065 51.6319 16.6065 50.165C16.6065 48.6964 15.4427 47.5035 13.9992 47.4867ZM13.9992 51.6495H9.56761V48.6757H13.9992C14.7946 48.6933 15.433 49.3547 15.433 50.165C15.433 50.974 14.7946 51.6319 13.9992 51.6495Z"
      fill={fill}
    />
    <path
      d="M22.6194 -39.9999V65.8864L12.4998 60.0204L2.38102 65.8855V-39.9999H0V69.025C0 69.318 0.237352 69.5557 0.532497 69.5557C0.625144 69.5557 0.710731 69.5309 0.787936 69.4881L0.793231 69.4907L12.4998 62.7031L24.2054 69.4889L24.2116 69.4863C24.2879 69.5309 24.3753 69.5557 24.4679 69.5557C24.7626 69.5557 25 69.318 25 69.025V-39.9999H22.6194Z"
      fill={fill}
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/svg/LogoBiblio/index.js